import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarBaseDirective } from './avatar-base/avatar-base.directive';
import { AvatarNameDirective } from './avatar-name/avatar-name.directive';
import { AvatarOrgDirective } from './avatar-org/avatar-org.directive';
import { AvatarDirective } from './avatar.directive';

@NgModule({
  declarations: [
    AvatarDirective,
    AvatarBaseDirective,
    AvatarNameDirective,
    AvatarOrgDirective,
  ],
  imports: [CommonModule],
  exports: [
    AvatarDirective,
    AvatarBaseDirective,
    AvatarNameDirective,
    AvatarOrgDirective,
  ],
})
export class AvatarModule {}
